import React, { useState } from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import { partners } from "../../constants";
import CalendyForm from "../MarketingLandingPage/CalendyForm";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const offwhite = css`
  background-color: #f6fbfb;
`;

const col1 = css`
  text-align: center;
`;

const contactImage = css`
  width: 275px;
  height: 200px;
  @media only screen and (min-width: 768px) {
    width: 400px;
  }
  @media only screen and (min-width: 900px) {
    width: 480px;
  }
  @media only screen and (min-width: 1200px) {
    width: 510px;
  }
`;
const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const H5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #89d2d3;
  margin: 10px 0px;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

function Partners({ history }) {
  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <main
          style={{
            width: "100%",
            minHeight: "calc(100vh - 70px)",
            backgroundColor: "rgb(255, 255, 255)",
            flex: "1 0 auto",
            textAlign: "center",
          }}
        >
          <div className={styles.row}>
            <div className={styles.maxWidthWrapper}>
              <div className={col + " " + col1} style={{ textAlign: "right" }}>
                <styles.H2
                  style={{
                    textAlign: "center",
                    margin: "30px 0px",
                    width: "100%",
                  }}
                >
                  <span className={styles.styledUnderline}>
                    Our Partnerships
                  </span>
                  <br></br>{" "}
                </styles.H2>
                <P style={{ textAlign: "center", fontSize: "18px" }}>
                  Mobile360 has created strategic partnerships to provide your
                  business the help you need to be successful.
                </P>
              </div>
            </div>
          </div>
          {partners.map((partner) => {
            return (
              <div className={styles.row}>
                <div
                  className={styles.maxWidthWrapper}
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <a
                    target="_blank"
                    href={partner.link}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        border: "1px solid " + partner.brandColor,
                        padding: "20px",
                        boxShadow: "rgb(120 120 120 / 50%) 3px 3px 13px",
                        borderRadius: "4px",
                      }}
                    >
                      <div
                        className={styles.col + " " + styles.half_col}
                        style={{ margin: "0px", textAlign: "center" }}
                      >
                        <img
                          className={contactImage}
                          src={partner.logo}
                          alt="marketing-img"
                          style={{
                            margin:
                              partner.name === "Insurance Canopy" ||
                              partner.name === "Zest Business Consulting"
                                ? "20px 0px"
                                : "0px",
                          }}
                        ></img>
                      </div>
                      <div className={styles.col + " " + styles.half_col}>
                        <P
                          style={{
                            textAlign: "left",
                            fontSize: "18px",
                          }}
                        >
                          <strong>{partner.name}</strong>: {partner.description}
                        </P>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            );
          })}

          <div className={styles.row}>
            {/************************************************************************************************
             *************************************************************************************************
             * Schedule a Demo Row
             * This row is for Calendy Demo scheduling
             *************************************************************************************************
             ************************************************************************************************/}
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col1}>
                <styles.H2
                  style={{
                    textAlign: "center",
                    width: "100%",
                    marginBottom: "30px",
                  }}
                >
                  Schedule a Free 30 Minute{" "}
                  <span className={styles.styledUnderline}>Demo</span>
                </styles.H2>
                <br></br>
                <CalendyForm />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default Partners;
